export const LogoMark = ({ size = 40, className = "", testid }) => (
  <img src={size > 200 ? "/logo-mark.png" : "/logo-mark-256.png"} width={size} height={size} alt="TRADE REPUBLIC"
    className={`shrink-0 select-none ${className}`} draggable={false} data-testid={testid} />
);

export const Logo = ({ compact = false, className = "", size = 40 }) => (
  <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
    <LogoMark size={size} />
    {!compact && (
      <div className="leading-none">
        <div className="font-display font-bold tracking-[0.22em] text-[16px]">TRADE</div>
        <div className="mt-1.5 flex items-center gap-1.5">
          <span className="h-px w-3 bg-[#D4A54A]" />
          <span className="font-display font-medium tracking-[0.38em] text-[9.5px] text-[#D4A54A]">REPUBLIC</span>
        </div>
      </div>
    )}
  </div>
);
